module.exports = __webpack_public_path__ + "static/img/equ4.b67850fa.png";